import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';

@ValidatorConstraint({ name: 'isFalse', async: false })
export class IsFalseConstraint implements ValidatorConstraintInterface {
  validate(value: any, args: ValidationArguments) {
    return value === false;
  }

  defaultMessage(args: ValidationArguments) {
    // Customize the error message here
    return `${args.property} must be false.`;
  }
}

export function IsFalse(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [],
      validator: IsFalseConstraint,
    });
  };
}
